import React from "react";

// Shared toggle + segmented control markup. The visual rules live with the
// consuming screen's stylesheet (`pg-toggle-card` / `pg-segmented`), which is
// why this file intentionally ships no CSS of its own.
export const BooleanToggle = ({ label, value, onChange, disabled = false }) => (
  <label className={`pg-toggle-card ${value ? "active" : ""} ${disabled ? "disabled" : ""}`}>
    <span>{label}</span>
    <input
      aria-label={label}
      checked={value}
      disabled={disabled}
      onChange={(event) => onChange(event.target.checked)}
      type="checkbox"
    />
    <span className="pg-toggle-track" aria-hidden="true">
      <span className="pg-toggle-thumb">{value ? "✓" : "×"}</span>
    </span>
  </label>
);

export const SegmentedControl = ({ options, value, onChange }) => (
  <div className="pg-segmented" role="tablist">
    {options.map((option) => (
      <button
        aria-selected={value === option.value}
        className={value === option.value ? "active" : ""}
        key={option.value}
        onClick={() => onChange(option.value)}
        role="tab"
        type="button"
      >
        {option.label}
      </button>
    ))}
  </div>
);
